/* =======================================================================
   SELLING POINTS LIGHTBOXES — OK Boomer Co.
   ======================================================================= */

(function () {
  if (window.__SP_LIGHTBOX_BOUND__) return;
  window.__SP_LIGHTBOX_BOUND__ = true;

  /* ── Scrollbar-shift compensation ────────────────────────────────
     Only fixed/sticky elements need explicit padding-right —
     they use viewport width, not the body's content-box width.
     The body's own padding-right compensates normal-flow children. */

  const STICKY_SELECTORS = [
    'sticky-header',
    '.header-wrapper',
    '.shopify-section-header-sticky'
  ];

  /* body.style.overflow = 'hidden' alone stops scrolling in every desktop
     browser, but iOS Safari has a long-standing bug where a touchmove drag
     still scrolls the underlying page even while the body is
     overflow:hidden — the drag "reaches through" the fixed modal and
     scrolls whatever's behind it. The standard, reliable fix is to also
     pin the body itself with position:fixed (recording the current scroll
     offset first) so there's no scrollable box left for the touch to grab,
     then restore the exact scroll position on close. */
  let lockedScrollY = 0;

  function lockScroll() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;

    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = scrollbarWidth + 'px';
    document.body.style.position = 'fixed';
    document.body.style.top = (-lockedScrollY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    STICKY_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.dataset.spPrPrev = el.style.paddingRight || '';
        el.style.paddingRight = scrollbarWidth + 'px';
      });
    });
  }

  function unlockScroll() {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    window.scrollTo(0, lockedScrollY);

    STICKY_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.paddingRight = el.dataset.spPrPrev || '';
        delete el.dataset.spPrPrev;
      });
    });
  }

  /* ── Dot colour map ─────────────────────────────────────────────── */

  const DOT_MAP = {
    birch:  '#F9DEB9',
    red:    '#9F2624',
    yellow: '#FFCA6E',
    green:  '#00B140',
    blue:   '#0047BB',
    black:  '#25282B'
  };
  const ORDER = ['birch', 'red', 'yellow', 'green', 'blue', 'black'];

  /* ── Height-lock IDs (JS reinforces CSS flex sizing) ────────────── */

  const HEIGHT_LOCK_IDS = new Set([
    'free-gift',
    'custom-builds',
    'customer-support',
    'warranty-promise',
    'warranty'
  ]);

  /* ── Slider (vanilla fader) ─────────────────────────────────────── */

  class VanillaFader {
    constructor(root, opts = {}) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('.sp-slide-item'));

      // Free-gift: lock to first slide (single colour display)
      const modalParent = root.closest('.sp-lightbox-modal');
      this.isLocked = modalParent && modalParent.getAttribute('data-lightbox-id') === 'free-gift';
      if (this.isLocked) this.slides = this.slides.slice(0, 1);

      this.index = 0;
      this.autoplay = opts.autoplay ?? true;
      this.speed = opts.autoplaySpeed ?? 4000;
      this.timer = null;
      this.dotsHost = opts.dotsHost || root.parentElement.querySelector('.sp-slider-dots');

      this.buildDots();
      this.go(0, true);
      this.bind();
      this.bindSwipe();
      if (this.autoplay) this.start();
    }

    buildDots() {
      if (!this.dotsHost) return;

      if (this.isLocked) {
        this.dotsHost.style.display = 'none';
        return;
      }

      const declaredKeys = this.slides.map(s => (s.getAttribute('data-color') || '').trim().toLowerCase());
      const usableDeclared = declaredKeys.map(k => DOT_MAP[k] ? k : '');
      const uniqueDeclared = new Set(usableDeclared.filter(Boolean));
      const useFallback = uniqueDeclared.size <= 1;

      const ul = document.createElement('ul');
      ul.className = 'sp-dots';

      this.slides.forEach((slide, i) => {
        const li = document.createElement('li');
        const b  = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', `Show image ${i + 1}`);

        const k = useFallback ? ORDER[i % ORDER.length]
                              : (usableDeclared[i] && DOT_MAP[usableDeclared[i]] ? usableDeclared[i] : ORDER[i % ORDER.length]);
        b.setAttribute('data-color', k);
        b.style.backgroundColor = DOT_MAP[k] || '#ccc';
        b.addEventListener('click', () => this.go(i));
        li.appendChild(b);
        ul.appendChild(li);
      });

      this.dotsHost.innerHTML = '';
      this.dotsHost.appendChild(ul);
      this.dotButtons = Array.from(ul.querySelectorAll('button'));
    }

    bind() {
      const col = this.root.closest('.sp-lightbox-column--image');
      if (!col) return;
      col.addEventListener('mouseenter', () => this.stop());
      col.addEventListener('mouseleave', () => this.start());
      document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start());
    }

    /* Touch-swipe navigation directly on the photo. Nick's ask: "swipe
       through the photos by swiping on the photo itself". Skipped entirely
       for single-slide sliders (free-gift) — nothing to swipe between.
       A horizontal-vs-vertical delta check (RESTRAINT) keeps a mostly-
       vertical drag (scrolling the lightbox body / page) from accidentally
       triggering a slide change, and .sp-slider's own `touch-action: pan-y`
       (assets/selling-points-lightbox.css) tells the browser up front that
       vertical panning is still expected here. */
    bindSwipe() {
      if (this.isLocked || this.slides.length < 2) return;

      const THRESHOLD = 40; // min horizontal travel, in px, to count as a swipe
      const RESTRAINT  = 60; // max vertical drift allowed alongside it

      let startX = 0;
      let startY = 0;
      let tracking = false;

      const onStart = (e) => {
        const t = e.touches ? e.touches[0] : e;
        startX = t.clientX;
        startY = t.clientY;
        tracking = true;
      };

      const onMove = (e) => {
        if (!tracking) return;
        const t = e.touches ? e.touches[0] : e;
        const dx = t.clientX - startX;
        const dy = t.clientY - startY;
        // Once a deliberate horizontal drag is underway, stop the browser
        // from also treating it as a page pan/back-swipe gesture. A mostly
        // vertical drag is left alone so body scrolling still works.
        if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) && e.cancelable) {
          e.preventDefault();
        }
      };

      const onEnd = (e) => {
        if (!tracking) return;
        tracking = false;
        const t = e.changedTouches ? e.changedTouches[0] : e;
        const dx = t.clientX - startX;
        const dy = t.clientY - startY;

        if (Math.abs(dx) >= THRESHOLD && Math.abs(dy) <= RESTRAINT) {
          this.stop();
          if (dx < 0) this.next(); else this.prev();
          setTimeout(() => this.start(), 2000);
        }
      };

      this.root.addEventListener('touchstart', onStart, { passive: true });
      this.root.addEventListener('touchmove', onMove, { passive: false });
      this.root.addEventListener('touchend', onEnd, { passive: true });
    }

    start() {
      if (!this.autoplay || this.slides.length < 2) return;
      this.stop();
      this.timer = setInterval(() => this.next(), this.speed);
    }

    stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }

    next() { this.go((this.index + 1) % this.slides.length); }
    prev() { this.go((this.index - 1 + this.slides.length) % this.slides.length); }

    go(i, immediate = false) {
      this.index = i;
      this.slides.forEach((el, idx) => {
        el.classList.toggle('is-active', idx === i);
        if (immediate) el.style.transition = 'none'; else el.style.removeProperty('transition');
      });
      if (this.dotButtons) {
        this.dotButtons.forEach((btn, idx) => {
          btn.classList.toggle('is-active', idx === i);
          btn.setAttribute('aria-current', idx === i ? 'true' : 'false');
        });
      }
    }
  }

  /* ── Main logic ─────────────────────────────────────────────────── */

  document.addEventListener('DOMContentLoaded', function () {
    const MODAL    = '.sp-lightbox-modal';
    const CLOSE    = '.sp-lightbox-close-button';
    const VISIBLE  = 'is-visible';
    let lastFocused = null;

    const getNumber = v => v ? parseFloat(v) : 0;

    function isStacked(modal) {
      const cols = modal.querySelector('.sp-lightbox-columns');
      return cols && getComputedStyle(cols).flexDirection === 'column';
    }

    /* Reinforce image-container height to match text column
       (CSS flex handles it, this is a safety net for edge cases) */
    function lockHeights(modal) {
      const id = modal.getAttribute('data-lightbox-id');
      if (!HEIGHT_LOCK_IDS.has(id)) return;

      const imgWrap = modal.querySelector('.sp-lightbox-image-container');
      const textCol = modal.querySelector('.sp-lightbox-column--text');
      if (!imgWrap || !textCol) return;

      if (isStacked(modal)) {
        imgWrap.style.height = 'auto';
        return;
      }

      // Content-light modals: size image to match text height exactly.
      // MIN of 160px ensures the subject is always visible even if text
      // is very short (e.g. viewport resize edge cases).
      if (id === 'customer-support' || id === 'warranty' || id === 'warranty-promise') {
        const MIN = id === 'customer-support' ? 160 : 260;
        const textH = Math.round(textCol.getBoundingClientRect().height);
        imgWrap.style.height = Math.max(MIN, textH) + 'px';
        return;
      }

      // General case: match text column height
      const dots = modal.querySelector('.sp-slider-dots');
      let dotsOuter = 0;
      if (dots && getComputedStyle(dots).display !== 'none') {
        const cs = getComputedStyle(dots);
        dotsOuter = Math.ceil(
          dots.getBoundingClientRect().height +
          getNumber(cs.marginTop) + getNumber(cs.marginBottom)
        );
      }

      const textH = Math.round(textCol.getBoundingClientRect().height);
      imgWrap.style.height = Math.max(240, textH - dotsOuter) + 'px';
    }

    /* Scroll-more-content cue: toggles .has-more-below on .sp-lightbox-body
       (see the fade-gradient ::after in selling-points-lightbox.css) based
       on whether the body actually has more content below the fold right
       now. Re-checked on open, on resize, and on every scroll of the body
       itself, so it appears/disappears in step with real content, rather
       than always being on (which would be misleading whenever a lightbox
       happens to fit without scrolling). */
    function updateScrollCue(modal) {
      const body = modal.querySelector('.sp-lightbox-body');
      if (!body) return;
      const hasMore = (body.scrollHeight - body.clientHeight - body.scrollTop) > 4;
      body.classList.toggle('has-more-below', hasMore);
    }

    function getFocusable(modal) {
      return Array.from(modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(el => el.offsetParent !== null || el === modal);
    }

    function handleKeys(e) {
      const m = document.querySelector(`${MODAL}.${VISIBLE}`);
      if (!m) return;

      const slider = m.querySelector('.sp-slider');
      const vf = slider && slider.__vf__;
      const focusables = getFocusable(m);
      const first = focusables[0];
      const last  = focusables[focusables.length - 1];

      if (e.key === 'Escape') {
        e.preventDefault();
        close(m);
        return;
      }

      if (vf && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
        e.preventDefault();
        vf.stop();
        if (e.key === 'ArrowRight') vf.next(); else vf.prev();
        setTimeout(() => vf.start && vf.start(), 2000);
        return;
      }

      if (e.key === 'Tab' && focusables.length) {
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    }

    function initSlider(modal) {
      const slider = modal.querySelector('.sp-slider');
      if (!slider) return;
      if (slider.__vf__) return slider.__vf__;
      const vf = new VanillaFader(slider, {
        autoplay: true,
        autoplaySpeed: 4000,
        dotsHost: modal.querySelector('.sp-slider-dots')
      });
      slider.__vf__ = vf;
      return vf;
    }

    function open(id) {
      const modal = document.querySelector(`${MODAL}[data-lightbox-id="${id}"]`);
      if (!modal) return;

      lastFocused = document.activeElement;

      lockScroll();

      modal.classList.add(VISIBLE);
      modal.setAttribute('aria-hidden', 'false');

      initSlider(modal);
      lockHeights(modal);
      updateScrollCue(modal);
      // Re-check once more after layout/fonts/images settle — lockHeights
      // above runs synchronously off a still-fresh layout in some cases.
      requestAnimationFrame(() => updateScrollCue(modal));

      document.addEventListener('keydown', handleKeys);

      const bound = () => { lockHeights(modal); updateScrollCue(modal); };
      modal.__resizeHandler = bound;
      window.addEventListener('resize', bound);

      const body = modal.querySelector('.sp-lightbox-body');
      if (body) {
        const scrollHandler = () => updateScrollCue(modal);
        modal.__scrollCueHandler = scrollHandler;
        body.addEventListener('scroll', scrollHandler, { passive: true });
      }

      setTimeout(() => {
        const b = modal.querySelector(CLOSE);
        if (b) b.focus();
        updateScrollCue(modal);
      }, 80);
    }

    function close(modal) {
      modal.classList.remove(VISIBLE);
      modal.setAttribute('aria-hidden', 'true');

      unlockScroll();

      document.removeEventListener('keydown', handleKeys);

      if (modal.__resizeHandler) {
        window.removeEventListener('resize', modal.__resizeHandler);
        modal.__resizeHandler = null;
      }

      if (modal.__scrollCueHandler) {
        const body = modal.querySelector('.sp-lightbox-body');
        if (body) body.removeEventListener('scroll', modal.__scrollCueHandler);
        modal.__scrollCueHandler = null;
      }

      if (lastFocused) lastFocused.focus();
    }

    /* Open via data-lightbox-target triggers */
    document.querySelectorAll('[data-lightbox-target]').forEach(t => {
      t.addEventListener('click', e => {
        e.preventDefault();
        const id = t.getAttribute('data-lightbox-target');
        if (id) open(id);
      });
    });

    /* Close via overlay click, close button, or clicking the wrapper directly */
    document.addEventListener('click', e => {
      const modal = e.target.closest(MODAL);
      if (!modal) return;
      if (e.target.closest('[data-close-lightbox]') || e.target.matches(MODAL)) {
        close(modal);
      }
    });
  });

})();
